import { useState, useEffect, useContext } from "react";
import { SideMenu } from "../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../components/data_table/data_table.component";
import OverLay from "../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../components/side_menu/overFlowSet.component";
import { MessageBar, Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, webDarkTheme, Card, Title2, Subtitle2, Subtitle1, Image, Input, ButtonProps } from "@fluentui/react-components";
import { DesktopCheckmark20Regular, WrenchScrewdriver20Regular, Filter20Filled, FilterDismiss20Filled, Desktop20Filled, ArrowMaximize20Regular, DismissSquare24Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, ArrowMaximize16Regular, Info16Filled, Info20Filled, Dismiss16Regular, AlertBadge20Regular, CheckmarkLock20Regular } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../components/dropdown/menu.component";
import { DropdownComponent } from "../../components/dropdown/dropdown.component";
import { Troubleshooter_func } from "../../api/troubleshoot/troubleshooter_func";
import { Compliance_Policy_func } from "../../api/troubleshoot/compliance_policy_func";
import { ToastComponent } from "../../components/toast/toast.component";
import { TroubleshooterDevice_fun } from '../../api/troubleshoot/troubleshooterDevice_fun';
import { Form } from '@rjsf/fluent-ui';
import validator from '@rjsf/validator-ajv8';
import { CustomWidgets } from '../../components/form-components';
import { GlobalContext } from "../../hooks/globalContext";
import { FullScreen } from "react-full-screen";
import { DataTableDevice } from "../../components/data_table/data_table.Device";
import { useFullScreenHandle } from "react-full-screen";
import { Activity_log_func } from "../../api/activity_log/activity_log_func";
import { shouldLoadRoute } from "../../Authentication/RouteProtection";
import { usePermissionStore } from "../../Store/permissionStore";

import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
} from "@fluentui/react-components";
import DialogBox from "../../components/dialog/dialog.component";
import { fullscreenIcon, primaryIcon, exitIcon, buttonContent, horizontalDivider, SubSectionResponsive, DynamicBoxingCSS, parentHome, wraperStyle, secondaryIcon, dashboardTheme, BreadcrumbsBorder, lightTheme, oveyAlignment, heightResponsive, tableDiv, overlayTableHeight } from "../../styles/customStyles";
import { SkeletonDataTable } from "../../components/skeleton/skeletonDataTable";
import FullScreenButton from "../../components/fullscreen/fullScreen.component";
import { InfoBar } from "../../components/infoBar/infoBar.component";
import { SearchBar } from "../../components/searchbar/searchbar.component";
import { TroubleshootPages } from "../../components/side_menu/InlineSidenav";

interface AccordionItem {
  heading: string;
  content: string;
}

export const Compliance_Policy = () => {
  const navigate = useNavigate();
  const [final_data, set_final_data]: any = useState(null);
  const [final_data1, set_final_data1]: any = useState(null);
  const [final_data2, set_final_data2]: any = useState(null);
  const [categoryData, setCategoryData]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const [leftOpen, setLeftOpen] = useState(false);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [isfilter, setIsFilter] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [searchDevVal, setSearchDevVal] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [totalSubPages, setTotalSubPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalSubRecords, setTotalSubRecords] = useState(0);
  const [messagebar1, setmessagebar1] = useState(false);
  const [messagebar2, setmessagebar2] = useState(false);
  const [subAutomationDetails, setSubAutomationDetails]: any = useState({});
  const [jsonSchema, setJsonData]: any = useState({});
  const [uiSchema, setUiData]: any = useState({});
  const [exportData, setExportData]: any = useState([]);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingTable, setLoadingTable] = useState(true);
  const handleBothSetMessage = () => {
    setmessagebar1(false);
    //setmessagebar2(true);
  };
  const [selectedData, setselectedData]: any = useState({ name: '', desc: '', displayName: '', subAutomation: '' });
  const [allDevice, setallDevice] = useState(false);
  const [groupName, setGroupName] = useState('');
  const [overLayData, setOverLayData] = useState({});
  const contextValue: any = useContext(GlobalContext);
  const tenantName = contextValue.tenantName;
  const [executeBtnClicked, setExecuteBtnClicked] = useState(false);
  const [toastMessage, setToastMessage] = useState('Push Failed');
  const [isRefresh, setIsRefresh]: any = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [isToast, setIsToast] = useState(false);

  const [tracker, setTracker]: any = useState(false);
  const [userActivityData, setUserActivityData] = useState({});

  const handle = useFullScreenHandle();
  const [accordionItems, setAccordionItems] = useState<AccordionItem[]>([]);
  const [machineStatus, setMachineStatus]: any = useState({});
  const [uniqueCat, setUniqueCat] = useState([]);
  const [columns2, setColumns2] = useState([]);
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  // const [permissions, setPermissions] = useState(['']);
  const { permissions } = usePermissionStore();
  console.log("checking the permissions------>", permissions);

  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    if (name === 'filter') {
      setDropDownValue2(enteredValue);
    }
  }
  const handleFilterArray = (): any => {
    const value1 = dropDownValue1
    const value2 = dropDownValue2;
    if (value1 !== undefined && value1 !== "" && value2 !== undefined && value2 !== "") {
      const result = value1 + " : " + value2;
      setFilterArray([...filterArray, result]);
      setIsFilter(true);
    }
  }

  const handleCloseFilter = (index: any): any => {
    console.log("clicked");
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
  }

  useEffect(() => {
    if (filterArray.length > 0)
      setResetDisabled(false)

  }, [filterArray])

  useEffect(() => {
    const newColumns2: any = uniqueCat.map((item) => {
      return {
        key: item,
        label: <Caption1>{item}</Caption1>
      };
    });
    setColumns2(newColumns2);
  }, [uniqueCat])

  useEffect(() => {

    final_data !== undefined && final_data !== null && final_data.length > 0
      ? final_data?.map((val: any, i: any) => {
        const newUniqueCat: any = [];

        final_data?.forEach((val: any) => {
          if (newUniqueCat.indexOf(val.Category) === -1) {
            newUniqueCat.push(val.Category);
          }
        });

        setUniqueCat(newUniqueCat);
      }) : (setUniqueCat([]))

  }, [final_data]);

  //data table column name code starts here
  var columns = [
    { key: "automationName", label: <Body1Strong>&nbsp; Name </Body1Strong> },
    { key: "description", label: <Body1Strong> Description </Body1Strong> },
    { key: "category", label: <Body1Strong> Category </Body1Strong> },
    // { key: "category_description", label: <Body1Strong> Category description </Body1Strong> },
    // { key: "subCategory", label: <Body1Strong> Sub Category </Body1Strong> },
    // { key: "sub_category_description", label: <Body1Strong> Sub Category description </Body1Strong> },
  ];
  //data table column name code ends here
  //the data table for filter starts here
  var columns1 = [
    { key: "automationName", label: <Caption1> Name </Caption1> },
    { key: "description", label: <Caption1> Description </Caption1> },
    { key: "category", label: <Caption1> Category </Caption1> },
    // { key: "subCategory", label: <Caption1> Sub Category </Caption1> },
  ];

  //overlay datatable code start here
  var overlayColumns = [
    { key: "host", label: <Body1Strong> Device Name</Body1Strong> },
    { key: "site", label: <Body1Strong> Device Classification </Body1Strong> },
    { key: "os", label: <Body1Strong> Operating System </Body1Strong> },
  ];

  var overlayColumns2 = [
    { key: "classificationName", label: <Body1Strong> All Device Name</Body1Strong> },
  ];
  //overlay datatable code ends here

  // overflow set contents code starts here
  var overFlowComponent = {
    data:
      <>
        <StackItem>
          <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setIsRefresh(true); setLoading(true) }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> {loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />} </StackItem>
              <StackItem> <Caption1> Refresh </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>

        <StackItem>
          <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_compliancepolicy.csv`}></CSVLink>
            <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => {setCurrentPageNo(1); setExportBtnClicked(true);}}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                <StackItem> <Caption1> Export </Caption1> </StackItem>
              </Stack>
            </Button>
        </StackItem>

        {/* <StackItem>
          <Button shape="circular" appearance="subtle" size="small">
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> <Settings20Regular {...primaryIcon} /> </StackItem>
              <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem> */}
        <StackItem grow shrink>
          <Stack horizontalAlign="end">
            <StackItem grow shrink>
              <FullScreenButton handle={handle} />
            </StackItem>
          </Stack>
        </StackItem>

      </>
    ,
  };
  // overflow set contents code ends here


  var timer: any;
  const searchHandle = (data: any) => {
    timer = clearTimeout(timer);

    timer = setTimeout(() => {
      setSearchVal(data.target.value);
      setCurrentPageNo(1);
    }, 1500);
  };

  var tempTableData: any = [];
  var menuLists: any = [];
  var tempExportData: any = [];

  // useEffect(() => {
  //   //roles and permissions
  //   async function loadRoute() {
  //     console.log("role:-",sessionStorage.getItem('role'))
  //     const role = sessionStorage.getItem('role');

  //     try {
  //       const [routeAllowed, permissions] = await shouldLoadRoute(role);

  //       if (routeAllowed) {
  //         console.log("permission===",permissions);

  //         setPermissions(permissions)
  //       } else {
  //         console.log('Route is not allowed.');
  //       }
  //     } catch (error) {
  //       console.error('Error loading route:', error);
  //     }
  //   }

  //   loadRoute();
  // }, []);

  useEffect(() => {
    var tempExportData: any = [];

    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      //var NewValue = val && JSON.parse(val.jsonValue);
      console.log("NewValue==============", val);

      tempExportData.push({
        'Name': val.automationName ? val.automationName : '-',
        'Description': val.description ? val.description : '-',
        'Category': val.category ? val.category : '-',
      });
    });

    setExportData(tempExportData);
  }, [exportDetails]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);


  const automationAction = async (val: any) => {
    setOverlayOpen(true);
    setallDevice(true);
    setselectedData({ name: val.automationName, desc: val.description, displayName: val.automationName, subAutomation: `${val.id}` })
  }

  useEffect(() => {
    // data table values append code starts here
    final_data !== undefined && final_data !== null
      ? final_data.map((val: any, i: any) => {
        var NewValue = val && JSON.parse(val.jsonValue);
        console.log('final_data : from final_data', val.dartid);

        tempTableData.push({
          id: NewValue.automationName,
          checkbox: "hide",
          automationName: { label: <Button id="ButtonHover" style={buttonContent} size="small" appearance="transparent" onClick={() => { automationAction(val) }}> {val.automationName} </Button>, icon: "", id: `${i}` },
          description: { label: <Caption1> {val.description ? val.description : "-"} </Caption1> },
          category: {
            label: <Caption1>
              {val.dartid === "2001"
                ? "All"
                : val.dartid === "2002"
                  ? "Business"
                  : val.dartid === "2003"
                    ? "Manoj"
                    : val.dartid === "2004"
                      ? "Business"
                      : "Business"}
            </Caption1>
          },
          jsonValue: { label: <Caption1> {val.jsonValue} </Caption1> },
        });
      }) : (tempTableData = []);
    tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);

    setTimeout(() => {
      final_data !== undefined && final_data !== null && setLoading(false);
    }, 500);
  }, [final_data]);
  // data table values append code ends here



  useEffect(() => {
    // Overlay data table values append code starts here
    console.log("final_data1*************", final_data1);
    console.log("machineStatus***********", machineStatus);

    final_data1 !== undefined && final_data1 !== null
      ? final_data1.map((val: any, i: any) => {

        var deviceStatus: any = Object.keys(machineStatus).length === 0 ? 'offline' : machineStatus[`${val.host}`] !== undefined ? machineStatus[`${val.host}`][0] : 'offline';
        var deviceType: any = Object.keys(machineStatus).length === 0 ? 'default' : machineStatus[`${val.host}`] !== undefined ? machineStatus[`${val.host}`][1] : 'default';

        var currentIcon = <Badge size="extra-small" appearance="filled" color={deviceStatus === 'online' ? "success" : "informative"} > </Badge>;

        if (deviceStatus === 'online') {
          if (deviceType == 1) {
            currentIcon = <Image src="/Dashboard/image/G_Win.svg" alt="Analyze Icon" />;
          } else if (deviceType == 2) {
            currentIcon = <Image src="/Dashboard/image/G_Android.svg" alt="Analyze Icon" />;
          } else if (deviceType == 5) {
            currentIcon = <Image src="/Dashboard/image/G_Apple.svg" alt="Analyze Icon" />;
          }
        } else if (deviceStatus === 'offline') {
          if (deviceType == 1) {
            currentIcon = <Image src="/Dashboard/image/Windows.svg" alt="Analyze Icon" />;
          } else if (deviceType == 2) {
            currentIcon = <Image src="/Dashboard/image/android.svg" alt="Analyze Icon" />;
          } else if (deviceType == 5) {
            currentIcon = <Image src="/Dashboard/image/apple.svg" alt="Analyze Icon" />;
          }
        }

        tempTableData.push({
          id: `${val.host}-/-${deviceStatus}`,
          host: { label: <Caption1> {val.host} </Caption1>, icon: currentIcon, id: `${i}` },
          site: { label: <Caption1> {val.site} </Caption1>, icon: "", status: "" },
          os: { label: <Caption1> {val.os} </Caption1> }
        });
      }) : (tempTableData = []);

    tempTableData.length > 0 ? setTableData1(tempTableData) : setTableData1([]);

    setTimeout(() => {
      console.log("fd1=", final_data1);

      final_data1 !== undefined && final_data1 !== null && setLoadingTable(false);
    }, 500);
  }, [final_data1, machineStatus]);

  useEffect(() => {
    // Overlay device table values append code starts here
    final_data2 !== undefined && final_data2 !== null
      ? final_data2 && final_data2.map((val: any, i: any) => {
        const deviceData = val && val.classificationName

        return <Caption1>{deviceData} </Caption1>;
      }) : (console.log("null"));
  }, [final_data2]);



  useEffect(() => {
    contextValue.setSelectedRowIdInTable([]);
  }, []);

  useEffect(() => {
    contextValue?.logedInFrom?.device?.length !== undefined && contextValue?.logedInFrom?.device?.length > 0 && setSearchDevVal(contextValue.logedInFrom.device);
  }, [contextValue.logedInFrom]);

  //overlay code starts here
  useEffect(() => {
    setOverLayData({
      headerTitle:
        (
          <StackItem>
            <FluentProvider theme={dashboardTheme}>
              <Title3>
                {selectedData.displayName.length > 0 ? selectedData.displayName : ''}

              </Title3>
            </FluentProvider>
          </StackItem>),
      size: "large",
      isTabs: true,

      tabItems: {
        // Introduction:
        //   <>
        //     <FluentProvider theme={dashboardTheme}>
        //       <Stack tokens={{ childrenGap: 15, padding: 10 }}>
        //         <StackItem> <Body1Strong> What does this Troubleshooter Do? </Body1Strong> </StackItem>
        //         <StackItem> <Caption1> Prevent data in Office mobile apps from being shared or leaked to unmanaged apps on iOS and Android devices. In this scenario, you’ll apply data protection settings to your organization’s managed mobile apps. </Caption1> </StackItem>
        //         <StackItem> <Body1Strong> What is the benefit? </Body1Strong> </StackItem>
        //         <StackItem> <Caption1> Prevent data in Office mobile apps from being shared or leaked to unmanaged apps on iOS and Android devices. In this scenario, you’ll apply data protection settings to your organization’s managed mobile apps. </Caption1> </StackItem>
        //         <StackItem> <Body1Strong> What is the User impact? </Body1Strong>  </StackItem>
        //         <StackItem> <Caption1> Assigned iOS and Android users must enter a PIN or use biometrics to access work or school content after a period of inactivity. After 5 failed PIN attempts, user must reset their PIN. </Caption1> <Caption1> If advanced data protection controls are enforced, users will not be able to share work or school content with personal apps or personal accounts and will be required to use Microsoft Edge. </Caption1> </StackItem>
        //         <StackItem> <Body1Strong> Prerequisites, if any</Body1Strong>  </StackItem>
        //         <StackItem> <Caption1> Managed Apps Create,Read,Assign,Delete Permission </Caption1> <Caption1> Policy sets read, create, and assign permissions. </Caption1> </StackItem>
        //       </Stack>
        //     </FluentProvider>
        //   </>,

        // Configuration:
        //   <>
        //     <Stack>
        //       {Object.keys(jsonSchema).length > 0 && Object.keys(uiSchema).length > 0 &&
        //         subAutomationDetails.core_AutomationJSON?.map((data: any, i: any) => {
        //           return (<Accordion collapsible><AccordionItem value="1">
        //             <AccordionHeader>{data.automationName}</AccordionHeader>
        //             <AccordionPanel>
        //               <Form formData={JSON.parse(data?.jsonValue)} schema={jsonSchema[`${data.dartid}`]} uiSchema={uiSchema[`${data.dartid}`]} validator={validator} widgets={CustomWidgets} disabled />
        //             </AccordionPanel>
        //           </AccordionItem> </Accordion>)
        //         })
        //       }
        //     </Stack>
        //   </>,

        Devices:
          <>

            <Stack id="troubleshootContainer" style={oveyAlignment} horizontalAlign="start">
              <StackItem style={DynamicBoxingCSS} grow shrink>
                {/* <Card appearance="subtle"> */}
                <Stack style={DynamicBoxingCSS} tokens={{ childrenGap: 10 }} horizontal>
                  <StackItem style={oveyAlignment}>
                    <Stack horizontal>
                    <Stack verticalFill>
                      <StackItem><Text></Text></StackItem>
                      {/* <StackItem> <Body1Strong>Data Classification</Body1Strong> </StackItem> */}
                      <StackItem> <Body1Strong>Devices Classification</Body1Strong> </StackItem>
                      <Stack tokens={{ childrenGap: 10 }}>
                        <StackItem><Text></Text></StackItem>
                        <StackItem><Divider /></StackItem>
                      </Stack>
                    </Stack>
                  </Stack>
                    <Stack  style={heightResponsive}>
                      <StackItem style={tableDiv}>
                        <StackItem onClick={() => { setGroupName(""); setallDevice(true); }}>
                          <FluentProvider theme={groupName === "" ? lightTheme : undefined}>
                            <MenuItem> All Devices</MenuItem>
                          </FluentProvider>
                          {/* <Button style={buttonContent} size="small" appearance="transparent">All Devices</Button> */}
                        </StackItem>
                        <Stack verticalFill>
                          {
                            final_data2 !== undefined && final_data2 !== null
                              ? final_data2 && final_data2.map((val: any, i: any) => {
                                const deviceData = val.classificationName;
                                return <StackItem onClick={() => { setGroupName(deviceData); setallDevice(false) }} >
                                  <FluentProvider theme={groupName === deviceData ? lightTheme : undefined}>
                                    <MenuItem><Body1> {deviceData} </Body1></MenuItem>
                                  </FluentProvider>
                                </StackItem>;
                              }) : (console.log("null"))
                          }
                        </Stack>
                      {tableData2.length > 0 && groupName != '' && (<DataTable tableData={tableData2} columns={overlayColumns2} />)}
                      {/* {loading ? (<SkeletonDataTable/>) : tableData2.length > 0 && groupName != '' ? (<DataTable tableData={tableData2} columns={overlayColumns2} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>} */}
                      </StackItem>
                    </Stack>
                  </StackItem>

                  <Divider vertical />

                  <StackItem style={DynamicBoxingCSS}>
                    {/* RIGHT SIDE DATA HERE */}
                    {/* <FluentProvider theme={messageTheme}>
                        <Card appearance="subtle" size="small">
                          <Stack tokens={{ childrenGap: 10 }} horizontal>
                            <StackItem> <Info20Filled {...primaryIcon} /> </StackItem>
                            <StackItem> <Caption1> Try changing or adding filters if you don't see what you're looking for. </Caption1>  </StackItem>
                          </Stack>
                        </Card>
                      </FluentProvider> */}
                    <InfoBar title={" Try changing or adding filters if you don't see what you're looking for."} />
                    <Stack tokens={{ padding: 5 }}>
                    {(contextValue?.logedInFrom === undefined || contextValue?.logedInFrom?.device?.length === undefined) && <Stack horizontal tokens={{ childrenGap: 20 }}>
                      <SearchBar columnSearch={"for Devices"} searchVal={searchDevVal} setSearchVal={setSearchDevVal} setLoading={setLoadingTable} disabled={loadingTable || tableData1.length === 0} />
                      <StackItem>
                        <MenuDropdown open={filterMenuOpen} btn={
                          <MenuButton disabled={loadingTable || tableData1.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                              {loadingTable || tableData1.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                              <Body1> Filter </Body1>
                            </Stack>
                          </MenuButton>
                        } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                          <Divider />
                          <MenuList>
                            <Stack tokens={{ childrenGap: 5 }}>
                              <StackItem> <Text></Text> </StackItem>
                              <StackItem> <Caption1> Filter </Caption1> </StackItem>
                              <DropdownComponent optionData={columns1} setDropDownValue={setDropDownValue1} dropDownvalue={dropDownValue1} />
                              <StackItem> <Divider /> </StackItem>
                              <StackItem> <Caption1> Value </Caption1> </StackItem>
                              <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />
                              <StackItem> <Divider /> </StackItem>
                              <Stack tokens={{ childrenGap: 10 }} horizontal>
                                <StackItem> <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false) }}> <Caption1> Apply </Caption1> </Button> </StackItem>
                                <StackItem> <Button shape="circular" onClick={() => setFilterMenuOpen(false)}> <Caption1> Cancel </Caption1> </Button> </StackItem>
                              </Stack>
                            </Stack>
                          </MenuList>
                        </>} />
                      </StackItem>
                      <StackItem>
                        {filterArray.length > 0 && filterArray.map((item, index) => (
                          <Button shape="circular" size="small">
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                              <StackItem> {item} </StackItem>
                              <StackItem>
                                <Stack tokens={{ childrenGap: 1 }}>
                                  <StackItem><Text></Text></StackItem>
                                  <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                </Stack>
                              </StackItem>
                            </Stack>
                          </Button>
                        ))}
                      </StackItem>
                      <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                        <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                          <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem> <FilterDismiss20Filled /> </StackItem>
                            <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                          </Stack>
                        </Button>
                      </StackItem>
                    </Stack>}
                    </Stack>
                    <Stack style={overlayTableHeight} tokens={{ childrenGap: 10 }}>
                    <FluentProvider style={DynamicBoxingCSS} theme={dashboardTheme}>
                        {loadingTable ? (<Stack style={DynamicBoxingCSS}><SkeletonDataTable /></Stack>) : tableData1.length > 0 ? (<Stack style={heightResponsive}><DataTable tableData={tableData1} columns={overlayColumns} /></Stack>) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No data available</Text></StackItem></Stack>}

                      </FluentProvider>
                    </Stack>
                </StackItem>
                </Stack>
                {/* </Card> */}
              </StackItem>
            </Stack>
          </>,

      },

      footerData:
        (
          <>
            {/* <Button shape="circular" appearance="primary" disabled={contextValue.selectedRowIdInTable.length > 0 ? false : true} onClick={() => { setmessagebar1(true); }}>
              Execute this Fix
            </Button> */}

            <DialogBox
              headerButton={
                <>
                  <Button shape="circular" appearance="primary" size="small" onClickCapture={() => setCurrentPageNo(1)}
                    disabled={contextValue.selectedRowIdInTable.length > 0 ? false : true}>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <Caption1> Push Policy </Caption1> </StackItem>
                    </Stack>
                  </Button>
                </>
              }

              content={`Are you sure you want to execute the solution: ${selectedData.displayName} solution on ${contextValue.selectedRowIdInTable
                .length} devices?`}

              footer=
              {
                <>
                  <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <StackItem>
                      <Button shape="circular" appearance="primary" onClick={handleBothSetMessage} size="small" onClickCapture={() => { setOverlayOpen(false); setExecuteBtnClicked(true); userActivity('add', `{"summary":"${selectedData.name}"}`); }}>Confirm</Button>
                    </StackItem>
                    <StackItem>
                      <Button shape="circular" size="small"  >Cancel</Button>
                    </StackItem>
                  </Stack>
                </>
              }
            />
            <DialogBox
              headerButton={
                <>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem>
                      <Button shape="circular" appearance="primary" size="small" /*onClick={() => { setPending(true) }}*/> Clear Pending queue </Button>
                    </StackItem>
                  </Stack>
                </>
              }

              content={"Are you sure you want to proceed with clearing pending jobs"}

              footer=
              {
                <>
                  <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <StackItem>
                      {<Button shape="circular" appearance="primary" size="small" onClick={() => { /*setPendingJob(true); */ }}> Confirm </Button>}
                    </StackItem>
                    <StackItem>
                      <Button shape="circular" size="small">Cancel</Button>
                    </StackItem>
                  </Stack>
                </>
              }
            />
          </>
        ),
    });
  }, [selectedData, groupName, final_data1, tableData1, contextValue.selectedRowIdInTable, searchDevVal, allDevice, subAutomationDetails, uiSchema, jsonSchema, final_data2])
  //overlay code ends here

  // useEffect(() => {
  //   //console.log("allDevice====",allDevice);
  // }, [allDevice])

  // useEffect(() => {
  //   //console.log("JsonData=",jsonSchema);
  //   //console.log("uiSchema=",uiSchema);
  // }, [jsonSchema, uiSchema])


  const userActivity = (action: String, activity: String, status: any = 'success') => {
    setUserActivityData({ pageName: 'Troubleshooter', moduleName: "troubleshoot", action: action, time: Math.floor(Date.now() / 1000), activity: activity, status: status });

    setTracker(true);
  }

  let deviceButtons = null;
  if (final_data2 !== undefined && final_data2 !== null) {
    deviceButtons = final_data2.map((val: any, i: any) => {
      const deviceData = val.classificationName;

      return (
        <StackItem key={i} onClick={() => { setGroupName(deviceData); setallDevice(false) }}>
          <Button shape="circular" appearance="transparent" size="small"> {deviceData} </Button>
        </StackItem>
      );
    });
  } else {
    console.log("null");
  }

  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink style={BreadcrumbsBorder}>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            {contextValue?.logedInFrom?.platform !== "ServiceNow" && <StackItem grow shrink>
              <Stack tokens={{childrenGap:5}} horizontalAlign="start">
                  <StackItem><Text></Text></StackItem>
                  <StackItem grow shrink> 
                      {/* <Breadcrumbs pageName="Alert" subPageName="" subPageLink="#" />  */}
                      <Breadcrumbs 
                          items={[
                          { name: "Manage", link: "/home" },
                          { name: "Troubleshoot", link: "/manage/troubleshoot/alert" },
                          { name: "Compliance Policy", link: "#" }
                          ]} 
                      />
                  </StackItem>
              </Stack>
            </StackItem>}
          </Stack>
        </StackItem>
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            <Stack style={DynamicBoxingCSS}>
              {/* <Stack tokens={{ childrenGap: 25 }} horizontal>
              <StackItem><Text/></StackItem>
                <StackItem>
                  <FluentProvider theme={dashboardTheme}>
                    <Title3>Troubleshooting | Compliance Policy</Title3>
                  </FluentProvider>
                </StackItem>

              </Stack> */}
              <FluentProvider style={parentHome} theme={dashboardTheme}>
                <Stack style={parentHome} horizontal>
                  <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={TroubleshootPages(`Compliance${" "}Policies`)} />
                  <StackItem style={DynamicBoxingCSS}>
                    <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                      <StackItem>
                        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                        <Divider />
                      </StackItem>
                      <StackItem style={wraperStyle}>
                        <StackItem>
                          <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                            <StackItem>
                              <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                              </StackItem>
                              <StackItem>
                                <MenuDropdown open={filterMenuOpen} btn={
                                  <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                      <Body1> Filter </Body1>
                                    </Stack>
                                  </MenuButton>
                                } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                  <Divider />
                                  <MenuList>
                                    <Stack tokens={{ childrenGap: 5 }}>
                                      <StackItem> <Text></Text> </StackItem>
                                      <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                      <DropdownComponent optionData={columns1} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                      <StackItem> <Divider /> </StackItem>
                                      <StackItem> <Caption1> Value </Caption1> </StackItem>
                                      {dropDownValue1 == "Category" && <DropdownComponent optionData={columns2} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}
                                      {dropDownValue1 == "Name" && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                      <StackItem> <Divider /> </StackItem>
                                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                                        <StackItem>
                                          <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                            disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                            <Caption1> Apply </Caption1>
                                          </Button>
                                        </StackItem>

                                        <StackItem>
                                          <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                            <Caption1> Cancel </Caption1>
                                          </Button>
                                        </StackItem>
                                      </Stack>
                                    </Stack>
                                  </MenuList>
                                </>} />
                              </StackItem>
                              <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem> <FilterDismiss20Filled /> </StackItem>
                                    <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                  </Stack>
                                </Button>
                              </StackItem>
                            </Stack>
                            {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                          </Stack>
                          {filterArray.length > 0 && <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                            <Stack wrap horizontal >
                              {filterArray.length > 0 && filterArray.map((item, index) => (
                                <Button shape="circular" size="small">
                                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                    <StackItem>
                                      <Stack tokens={{ childrenGap: 1 }}>
                                        <StackItem><Text></Text></StackItem>
                                        <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                      </Stack>
                                    </StackItem>
                                  </Stack>
                                </Button>
                              ))}
                            </Stack>
                          </Stack>}
                        </StackItem>
                        <InfoBar showSpaces={true} title={"Executing the following troubleshooters will assist you in devices management and provide a resolutions for any errors. Be mindful  when executing the troubleshooter on multiple devices."} />
                        {tableData.length > 0 && <Stack horizontal enableScopedSelectors horizontalAlign="space-between" >
                          <StackItem>
                            <Caption1> Showing {(currentPageNo - 1) * 50 + 1} to {currentPageNo * 50 > totalRecords ? totalRecords : currentPageNo * 50} of {totalRecords} Records </Caption1>
                          </StackItem>
                        </Stack>}
                      </StackItem>

                      <Troubleshooter_func data={final_data} func={set_final_data} searchVal={searchVal} pageNo={(currentPageNo - 1) * 50} setTotalPages={setTotalPages} setTotalRecords={setTotalRecords} setExecuteBtnClicked={setExecuteBtnClicked} executeBtnClicked={executeBtnClicked} selectedAuto={selectedData} setmessagebar={setmessagebar2} setmessage={setToastMessage} isRefresh={isRefresh} setIsRefresh={setIsRefresh} setRefreshToast={setRefreshToast} setSubAutomationDetails={setSubAutomationDetails} setJsonData={setJsonData} setUiData={setUiData} setExportDetails={setExportDetails} isFilter={isfilter} filterArray={filterArray} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2} setCategoryData={setCategoryData} pageName={'compliancepolicy'} 
                      setExportBtnClicked={setExportBtnClicked} exportBtnClicked={exportBtnClicked}/>

                      <TroubleshooterDevice_fun groupData={final_data2} groupFunc={set_final_data2} data={final_data1} func={set_final_data1} searchDevVal={searchDevVal} pageNo={(currentPageNo - 1) * 10} setTotalPages={setTotalSubPages} setTotalRecords={setTotalSubRecords} groupName={groupName} setGroupName={setGroupName} allDevice={allDevice} overlayOpen={overlayOpen} setallDevice={setallDevice} setMachineStatus={setMachineStatus} />

                      {/* {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />} */}
                      {refreshToast && <ToastComponent setmessagebar={setRefreshToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}

                      {/* {tableData.length > 0 && (<DataTable tableData={tableData} columns={columns} />)} */}
                      {/* <SkeletonDataTable/> */}
                      {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={columns} ></DataTable>) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                      {tracker && <Activity_log_func data={userActivityData} setTracker={setTracker} type="insertLog" />}
                    </Stack>
                  </StackItem>
                </Stack>
              </FluentProvider>
            </Stack>


            <OverLay
              overlayopen={overlayOpen}
              setOverlayOpen={setOverlayOpen}
              overlayData={overLayData}
            />

          </StackItem>
          <StackItem><Text></Text></StackItem>
        </Stack>
      </FullScreen>

      <StackItem>
        {messagebar2 && (
          <ToastComponent setmessagebar={setmessagebar2}
            toastIntent="success"
            position="top-end"
            title="Success"
            message={toastMessage} />
        )}
      </StackItem></>
  );
};